// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__MGlOr","content":"LayoutSettings_content__2HqZ3"};